import type { ReactNode } from "react";

// Badge/Pill — status color is meaningful, not decorative (design review): the tone
// carries the semantic (success/danger/warning), the label is passed in.
export type BadgeTone = "neutral" | "success" | "danger" | "warning";

export function Badge({ tone = "neutral", children }: { tone?: BadgeTone; children: ReactNode }) {
  const t = tone === "neutral" ? "" : ` ui-badge--${tone}`;
  return <span className={`ui-badge${t}`}>{children}</span>;
}
